import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import {
  PATH_ASSIGNMENTS,
  PATH_USER_ASSIGNMENTS,
  PATH_ASSIGNMENTS_BY_USER_ID,
  PATH_ASSIGNMENTS_DEACTIVATE_IN_BULK
} from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const assignments = {
  namespaced: true,
  state: buildInitialState({
    assignmentList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setAssignments: (state, assignments) => {
      state.assignmentList = assignments
      // Add assignmentSelected for list view
      state.assignmentList = state.assignmentList.map(i => {
        return {
          ...i,
          assignmentSelected: false
        }
      })
    }
  },
  actions: {
    getAssignments: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting contracts, please wait...' })

      return api.doGet({ path: PATH_ASSIGNMENTS, parameters: filters })
        .then(json => json.data)
        .then(assignments => {
          commit('updateStatus', { status: COMPLETE })
          if (Array.isArray(assignments)) {
            commit('setAssignments', assignments)
          } else {
            let assignmentsList = []
            assignmentsList.push(assignments)
            commit('setAssignments', assignmentsList)
          }
          return assignments
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get contracts')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getAssignmentsByUserId: ({ commit, dispatch }, userId) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting contracts, please wait...' })

      return api.doGet({ path: PATH_ASSIGNMENTS_BY_USER_ID, parameters: { userId: userId } })
        .then(json => json.data)
        .then(assignments => {
          commit('updateStatus', { status: COMPLETE })
          return assignments
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get contracts')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getUserAssignments: ({ commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting contracts, please wait...' })

      return api.doGet({ path: PATH_USER_ASSIGNMENTS })
        .then(json => json.data)
        .then(assignments => {
          commit('updateStatus', { status: COMPLETE })
          commit('setAssignments', assignments)
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get contracts')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getFieldsWithFilters: ({ dispatch, rootGetters }) => {
      return dispatch('getAssignments', { ...rootGetters['assignmentFilters/getSearchObject'] })
    },
    deactivateAssignmentInBulk: ({ commit, dispatch }, payload) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Deactivating contracts, please wait...' })
      return api.doPut({ path: PATH_ASSIGNMENTS_DEACTIVATE_IN_BULK, data: payload })
        .then(json => json.data)
        .then(deactivateInBulkResponse => {
          commit('updateStatus', { status: COMPLETE })
          return deactivateInBulkResponse
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to deactivate contracts')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default assignments
